import { render, staticRenderFns } from "./previewBSQR.vue?vue&type=template&id=6e871adb&lang=html&"
import script from "./previewBSQR.vue?vue&type=script&lang=js&"
export * from "./previewBSQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports